import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import authAxios from "../../../../config/authAxios"




const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const getVerifyBank = createAsyncThunk(
    'get-verify-banks',
    async (data, { rejectWithValue }) => {
        try {
            const res = await authAxios.patch(`/support-server/api/verify-bank-details`,data)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getVerifyBankSlice = createSlice({
    name: 'get-publisher-details',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getVerifyBank.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getVerifyBank.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(getVerifyBank.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const getVerifyBankReducer = getVerifyBankSlice.reducer